// eslint-disable-next-line import/prefer-default-export
export const resultAttributes = [
  'url',
  'page_title',
  'promote',
  'target_audience_id',
  'image_style_uri',
  'event_date',
  'event_date_end_value',
  'event_date_infinite',
  'recurring_date_fields',
  'computed_first_upcoming_start_date',
  'computed_first_upcoming_date_index',
];
